import LocalizedStrings from 'react-localization';

export const strings = new LocalizedStrings({ en: require('./en.json'), 
                                              de: require('./de.json') })

